import { useSelector } from "react-redux";
import Button from "../../common/Button";
import RemoveDataConfirmationModal from "../../common/RemoveDataConfirmationModal";
import { resetDataForCase } from "../../../lib/fetchApi";
import { useState } from "react";

export default function ClearDataTest({type, btnTitle}) {

    const activeCase = useSelector(state => state.case.activeCase)
    const userToken = useSelector(state => state.user.token)

    const [loading, setLoading] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)


    async function clearDataForTesting() {
        setShowConfirm(false)
        setLoading(true)

        const response = await resetDataForCase(userToken, activeCase?.case?.id, type)

        if (response && response.success) {
            // if (!type) {
                window.location.reload()
            // }
        }

        setLoading(false)
    }
    
    return <div style={{ position: 'relative' }}>
        <Button click={() => setShowConfirm(true)} isLoading={loading} bypassisCaseArchived={true}>
            <i className="ti ti-x"></i>
        </Button>
        {showConfirm && <RemoveDataConfirmationModal
            closeModal={() => setShowConfirm(false)}
            removeData={clearDataForTesting}
            message={'Are you sure you want to reset this case?'}
            confirmLabel={'Reset'}
            position={'right'}
        />}
    </div>
}